// extracted by mini-css-extract-plugin
export var container = "privacy-module--container--9L9dk";
export var content = "privacy-module--content--+8UIb";